import React from "react";
import "./webhooksTable.css";

const ConfirmAction = ({ message, onConfirm, onCancel }) => {
  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal-content">
        <p>{message}</p>
        <div className="confirm-modal-buttons">
          <button onClick={onConfirm} className="confirm-btn">
            Yes
          </button>
          <button onClick={onCancel} className="cancel-btn">
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmAction;
